import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { BRAND } from '../theme/brand';

const stats = [
  { value: '40+', label: 'Features & tools' },
  { value: '4', label: 'Languages supported' },
  { value: '24/7', label: 'Makkah Live access' },
  { value: 'Free', label: 'Core app — no ads' },
];

const StatsBar = () => (
  <Box
    sx={{
      py: { xs: 4, md: 5 },
      backgroundColor: '#fff',
      borderBottom: `1px solid ${BRAND.border}`,
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        {stats.map((stat) => (
          <Grid item xs={6} md={3} key={stat.label}>
            <Box
              sx={{
                textAlign: 'center',
                px: 2,
                py: { xs: 2, md: 2.5 },
                borderRadius: 2,
                border: `1px solid ${BRAND.border}`,
                backgroundColor: BRAND.surface,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: '1.5rem', md: '1.75rem' },
                  color: BRAND.teal,
                  mb: 0.5,
                  lineHeight: 1,
                }}
              >
                {stat.value}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: BRAND.textMuted, fontWeight: 500, fontSize: '0.875rem' }}
              >
                {stat.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default StatsBar;
